<template>
<div class="full-nav">
  <div class="uppernav">
    <a href='https://www.openagent.com.au'>
      <img class="logo ut-mt-1" src="@/assets/styles/frontend-library/images/logo-openagent-green-grey.svg" alt="OpenAgent.com.au" width="200"></a>

    <div class="mobilenav ut-inline md:ut-hidden">
      <div @click="showLinks = !showLinks" class="menubox ut-inline-flex ut-float-right ut-p-1 ut-cursor-pointer ut-bg-Nnew ut-rounded ut-text-sm">
        <span class="ut-p-2 ut-text-Gnew">MENU</span>
        <img src="@/assets/styles/frontend-library/images/menu.svg">
      </div>
      <div @click="showSearch = !showSearch" class="searchicon ut-float-right ut-py-2 ut-px-4 ut-cursor-pointer"><img src="@/assets/styles/frontend-library/images/search-icon-green.svg"></div>
    </div>
    <transition name="slide">
      <SuburbSearch v-if="showSearch" :placeholderText="'Enter a suburb to find top real estate agents'" class="suburbsearch ut-mt-4 md:ut-float-right" @selectedResult="getSuburb"></SuburbSearch>
    </transition>

    <SuburbSearch class="ut-hidden suburbsearch md:ut-float-right md:ut-block" :showIcon="true" :placeholderText="'Enter a suburb to find top real estate agents'" @selectedResult="getSuburb"></SuburbSearch>

    <transition name="slide">
      <ul class="navlinks" v-if="showLinks">
        <li><a @click="showLinks = false" href="https://www.openagent.com.au/find-real-estate-agents" class="linkitem">Find agents</a></li>
        <li><a @click="showLinks = false" href="https://www.openagent.com.au/property-reports" class="linkitem">Property reports</a></li>
        <li><a @click="showLinks = false" href="https://www.openagent.com.au/tools/commissions-calculator" class="linkitem">Commision Calculator</a></li>
        <li><a @click="showLinks = false" href="https://www.openagent.com.au/blog/category/market-news" class="linkitem">Real estate news</a></li>
      </ul>
    </transition>

  </div>

  <div class="linksbox">
    <div class="links ut-w-full">
      <div class="innerlinks">
        <a href="https://www.openagent.com.au/find-real-estate-agents" class="linkitem">Find agents</a>
        <a href="https://www.openagent.com.au/property-reports" class="linkitem">Property reports</a>
        <a href="https://www.openagent.com.au/tools/commissions-calculator" class="linkitem">Commision Calculator</a>
        <a href="https://www.openagent.com.au/blog/category/market-news" class="linkitem">Real estate news</a>
      </div>
      <div class="phonetext">Get free agent advice on <img src="@/assets/styles/frontend-library/images/phone-white.svg"><a href="tel:02132434">13 24 34</a></div>
    </div>
  </div>

</div>
</template>

<script>
import SuburbSearch from '@/components/forms/search/SuburbSearch.vue';

export default {
  name: 'FullNav',
  props: {},
  data() {
    return {
      suburbvar: null,
      showSearch: false,
      showLinks: false,
    };
  },
  components: {
    SuburbSearch,
  },
  methods: {
    getSuburb(selected) {
      this.suburbvar = selected;
      const query = {
        postcode: this.suburbvar.postcode,
        postcodeid: this.suburbvar.id,
        state: this.suburbvar.state,
        suburb: this.suburbvar.suburb,
      };
      this.$store.state.query = query;
      this.$router.push({
        name: 'Home',
        query: this.$store.state.query,
      });
      window.location.href = `https://www.openagent.com.au/smartsearch?pid=${this.suburbvar.id}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.full-nav {

    .suburbsearch {
        width: 100%;
        @screen md {
            max-width: 350px;
        }
    }

    .navlinks {
        list-style: none;
        padding: 0;
        margin-top: 10px;
        li {
            @apply ut-text-Gnew;
            padding: 10px 0;
            border-bottom: 1px solid rgba(151, 151, 151, 0.2);

            &:last-child {
                border: none;
            }
        }
    }

    .slide-enter-active {
        -moz-transition-duration: 0.3s;
        -webkit-transition-duration: 0.3s;
        -o-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -moz-transition-timing-function: ease-in;
        -webkit-transition-timing-function: ease-in;
        -o-transition-timing-function: ease-in;
        transition-timing-function: ease-in;
    }

    .slide-leave-active {
        -moz-transition-duration: 0.3s;
        -webkit-transition-duration: 0.3s;
        -o-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    }

    .slide-enter-to,
    .slide-leave {
        max-height: 100px;
        overflow: hidden;
    }

    .slide-enter,
    .slide-leave-to {
        overflow: hidden;
        max-height: 0;
    }

    .uppernav {
        max-width: 1120px;

        @apply ut-px-6 ut-py-3 ut-pb-4;

        @screen md {
            padding: 20px 5%;
        }

        .logo {
            max-width: 130px;
        }

    }
    .linksbox {
        @apply ut-bg-Gnew;
    }
    .links {

        @apply ut-hidden ut-bg-Gnew ut-text-N20;

        @screen lg {
            @apply ut-flex;
            max-width: 1120px;
        }

        .innerlinks {
            @apply ut-inline-flex ut-flex-auto ut-justify-start ut-font-bold;
        }
        .linkitem {
            @apply ut-pl-8 ut-cursor-pointer ut-inline-flex ut-flex-auto ut-justify-center ut-font-bold;

            line-height: 43px;

            @screen xl {
              @apply ut-pl-0 ut-justify-start;
            }

            &:hover {
            }
        }
        .phonetext {
          line-height: 43px;
            @apply ut-inline-flex ut-justify-center;
            img {
              margin-left: 10px;
            }
            a {
              padding-left: 5px;
              // margin: 0;
            }
            @screen xl {
              @apply ut-justify-end;
            }
        }
    }
}
</style>
